const tooltiptitle = {
  id: 'schedulePMFlowDialog.tooltipTitle',
}

const textIds = {
  tooltiptitle,
}

export default textIds
